import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { dispatcher } from 'dispatcher';
import { prop } from 'ramda';
import { useNavigate } from 'js/hooks/navigate';
import { useAppSelector } from 'js/store/hooks';
import { useConfirmationPopup } from 'js/components/common/popups/ConfirmationPopup';
import { useOnClose } from 'js/components/common/PopupManager';

export const useNavigateFromRegister = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const rootPage = useAppSelector(prop('rootPage'));
    const { prevPath } = location.state || {};
    const root = prevPath === rootPage ? '/' : rootPage;
    const showConfirmationPopup = useConfirmationPopup();
    const closeManagedPopup = useOnClose();
    const navigateAndDispatch = () => {
        dispatcher.dispatch('backButton:show');
        navigate(root);
    };

    return useCallback(() => {

        showConfirmationPopup({
            isModal: false,
            className: 'confirmation_close_reg_popup',
            content: 'playtech.mobile.system.registrationCloseConfirm.confirmationText',
            buttons: [
                {
                    onClick: () => {
                        navigateAndDispatch();
                        closeManagedPopup();
                    },
                    text: 'playtech.mobile.system.registrationCloseConfirm.acceptBtnText'
                }
            ]
        });
    }, [prevPath, rootPage, navigate, showConfirmationPopup]);
};
